<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'" id="adminHome"><a
        routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role === 'DEMO_ACCOUNT'"
          id="accountOwnerHome"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'" id="userHome"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Customers</li>
    </ol>
  </nav>

  <div class="invalid-feedback d-block shift-invalid-text w-75" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div class="row align-items-center"
       *ngIf="totalCount>0 && (user.role === 'ACCOUNT_OWNER' ||user.role === 'DEMO_ACCOUNT' ||user.role === 'ROLE_USER') ">
    <div class="col-8">
      <ul class="list-inline tab-list deskContent">
        <li class="list-inline-item" id="all"><a (click)="populateTabData('all','ALL'); resetCheckedList(); tabChange()"
                                                 [ngClass]="{'active': tabClicked === 'all'}">All</a></li>
        <li class="list-inline-item" id="active"><a
          (click)="populateTabData('active','ACTIVE');resetCheckedList(); tabChange()"
          [ngClass]="{'active': tabClicked === 'active'}">Active</a></li>
        <li class="list-inline-item" id="inActive"><a
          (click)="populateTabData('inactive','IN_ACTIVE');resetCheckedList(); tabChange()"
          [ngClass]="{'active': tabClicked === 'inactive'}">Inactive</a></li>
      </ul>
      <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
              [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;"
              data-value="All" required>
        <option value="ALL">All</option>
        <option value="ACTIVE">Active</option>
        <option value="IN_ACTIVE">Inactive</option>
      </select>
    </div>
    <div class="col text-right float-right"
         *ngIf="user.role === 'ACCOUNT_OWNER' || user.role === 'DEMO_ACCOUNT' ||(user.role === 'ROLE_USER' && accessSec.createCustomer)">
      <a placement="bottom" class="ml-2" ngbTooltip="Export To Excel"  *ngIf= "contacts?.length">
        <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSXCustomers()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
      </a>
      <a placement="bottom" ngbTooltip="Create" class="ml-2">
        <svg xmlns="http://www.w3.org/2000/svg" (click)="submitContacts()" width="30" height="30" viewBox="0 0 30 30">
          <defs>
            <style>.a {
              fill: #8a55bb;
            }

            .b {
              fill: #fff;
            }
            </style>
          </defs>
          <g transform="translate(4 2.5)">
            <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
            <path class="b"
                  d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                  transform="translate(2.823 3.938)"/>
          </g>
        </svg>
      </a>
    </div>
  </div>

  <div class="row" *ngIf="!totalCount && !loading">
    <div class="col">
      <div class="inner-box no-listbox">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-right">
            <img src="assets/images/Emptyscreen - Customers.png">
          </div>
          <div class="col-md-6">
            <h2>Be the one to start</h2>
            <h1 class="f-46 text-orange">Create your first Contact!!</h1>
            <a (click)="submitContacts()"
               *ngIf="user.role === 'ACCOUNT_OWNER' ||user.role === 'DEMO_ACCOUNT' ||(user.role === 'ROLE_USER' && accessSec.createCustomer)">
              <button class="btn btn-orange-prime mt-4" id="createNow">Create now</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    [hidden]="!totalCount && (user.role === 'ACCOUNT_OWNER' ||user.role === 'DEMO_ACCOUNT' ||user.role === 'ROLE_USER') ">
    <div class="row">
      <div class="col">
        <div class="inner-box d-none d-sm-block">
          <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
            <thead>
            <tr>
              <th>Contact Person</th>
              <th>Company Name</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Customer Type</th>
              <th>Status</th>
            </tr>
            </thead>
            <tbody class="table-body-custom">
            <tr *ngFor="let c of contacts;let i = index">
                            <td style="text-transform:capitalize;"><a routerLink="/admin/viewCustomer/{{c.accountOwnerContactId}}"
               [ngClass]="{'disabled':(user.role === 'ROLE_USER' && !accessSec.editCustomer)}">{{c.contactName}}</a>

              </td>
              <td>{{c.companyName}}</td>
              <td>{{c.email}}</td>
              <td>{{c.mobile}}</td>
              <td>{{c.customerType | replaceStatus}}</td>
              <td>
                <div class="toggle-2">
                  <input type="checkbox" name="onoffswitch" id="customSwitch_{{c.accountOwnerContactId}}"
                         class="custom-control-input" (click)="updateStatus(c)" [checked]="c.status==='ACTIVE'"
                         class="checkbox"/>
                  <label for="customSwitch_{{c.accountOwnerContactId}}" class="toggle">
                    <span>ON</span><span>OFF</span>
                  </label>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="display-msg text-center">
            {{displayMsg}}
          </div>
        </div>
        <div class="inner-box d-block d-sm-none">
          <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
            <thead>
            <tr>
              <th>Company Name</th>
              <th>Phone Number</th>
              <th>Email</th>
              <th>Contact Person</th>
              <th>Customer Type</th>
              <th>Status</th>
              </tr>
            </thead>
            <tbody>

            <tr *ngFor="let c of contacts;let i = index">
              <td>
                <b class=" tablesaw-cell-label">Contact Person</b>
                <a routerLink="/admin/editContacts/{{c.accountOwnerContactId}}"
                   [ngClass]="{'disabled':(user.role === 'ROLE_USER' && !accessSec.editCustomer)}">
                  <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{c.contactName}}</span>
                </a>
              </td>

              <td>
                <b class=" tablesaw-cell-label">Customer Type</b>
                <span class="tablesaw-cell-content"
                      style="text-transform:capitalize;">{{c.customerType | replaceStatus}}</span>
              </td>

              <td><b class=" tablesaw-cell-label">Phone Number</b>
                <span class="tablesaw-cell-content">{{c.mobile}}</span></td>

              <td><b class=" tablesaw-cell-label">Email</b>
                <span class="tablesaw-cell-content">{{c.email}}</span></td>

              <td><b class=" tablesaw-cell-label">Company Name</b>
                <span class="tablesaw-cell-content">{{c.companyName}}</span></td>
              <td>
                <b class=" tablesaw-cell-label">Status</b>
                <span class="tablesaw-cell-content">
                    <div class="custom-control custom-switch "
                         [ngClass]="{'contact-status':(user.role === 'ROLE_USER' && !accessSec.editCustomer)}">
                      <input type="checkbox" class="custom-control-input" (click)="updateStatus(c)"
                             id="customsSwitch_{{c.accountOwnerContactId}}"
                             [disabled]="(user.role === 'ROLE_USER' && !accessSec.editCustomer)"
                             [checked]="c.status==='ACTIVE'">
                      <label class="custom-control-label" for="customSwitch_{{c.accountOwnerContactId}}"> </label>
                    </div>
                  </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>



<div [ngClass]="{'modal': statusUpdate == 'Y'}" [ngStyle]="{'display': statusUpdate  == 'Y'? 'block' : 'none'}" style="overflow-y:auto"  class="modal fade show" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="padding-top:100px;">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Confirmation</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="closepopUpRequest()">&times;</button>
      </div>
      <div class="modal-body">
        <label class="mb-3">Do you want update the status</label>
      </div>
      <div class="modal-footer">
        <button (click)="closepopUpRequest()" class="btn btn-cancel" type="button">No</button>
        <button (click)="changeStatus()" class="btn icon-left btn-orange-primary ml-3" type="button">Yes
        </button>
      </div>
    </div>
  </div>
</div>
